import * as Cache from '@/lib/cache'

import { loginByCode, getInfo } from '@/api/user'
// import { getThemeArticleByTime } from '@/api/activity'

import * as MutationTypes from '../mutation-types'
import * as ActionTypes from '../action-types'

//创建Vuex实例
const state = {
  // loginStatus: Cache.loadLoginStatus(), // 登录状态
  // token: Cache.loadToken(), // token
  loginStatus: process.env.NODE_ENV === "development" ? 2 : Cache.loadLoginStatus(), // 登录状态
  // token: 'eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiI3Iiwic3ViIjoiTG92ZXkiLCJpc3MiOiIiLCJhdWQiOiIiLCJpYXQiOjE2MDIyMjk2NDksImV4cCI6MTYwMjUzMjA0OX0.h1yhL2Vq2OwGYvEun542euWuutyYyjgkryoPK5QgzYma7W-IWEWYKQznrxRu4-TGC1HpLbTc3hQc4SOIemAnCA',
  token: process.env.NODE_ENV === "development" ? 'eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiIxMDAzMyIsInN1YiI6Iua4o-a4o1x1RDgzRVx1REQyMyIsImlzcyI6IiIsImF1ZCI6IiIsImlhdCI6MTYwMjI0Mzk0NywiZXhwIjoxNjAyNTQ2MzQ3fQ.i-ms4d_R5ZELpGkKEsP7TWtIiogebfNXH2nu0twrQSMMvOzREs1eP3wEcAwRXwYnhL6z2W-BIFW3Cxx0QFy2RA' : Cache.loadToken(),
  userInfo: Cache.loadUserInfo(), // 用户登录信息
}

const mutations = {
  [MutationTypes.SET_USERINFO]: (state, userInfo) => {
    state.userInfo = userInfo
  },
  [MutationTypes.SET_LOGIN_STATUS]: (state, loginStatus) => {
    state.loginStatus = loginStatus
  },
  [MutationTypes.SET_TOKEN]: (state, token) => {
    state.token = token
  },
}
const actions = {
  action_setInfo({ commit },data) {
    commit(MutationTypes.SET_USERINFO,Cache.saveUserInfo(data))
  },
  // 登录相关，通过code获取token和用户信息
  loginWechatAuth({ commit }, code) {
    return new Promise((resolve, reject) => {
      loginByCode(code)
        .then(res => {

          commit(MutationTypes.SET_TOKEN, Cache.saveToken(res.data.accessToken))
          console.log('accessToken=======',res.data.accessToken)
          this.dispatch(ActionTypes.GET_USER_INFO)
          resolve(res)

        })
        .catch(error => {
          reject(error)
        })
    })
  },

  //获取用户信息
  action_getiInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(res => {
        // 存用户信息，
        // dayCount: 0
        // headImageUrl: "http://thirdwx.qlogo.cn/mmopen/Yiaz1xk3ur1nYcQoVr7zk7ibqt0W4AFkp7JwMG7qiagdY4NokTXdgQyyKlickewE92Usn56q6CtwtF21FstdZ3MhlKdvZuUlxV9B/132"
        // nickname: "alien"
        // rewardPoint: 0
        // vipExpireDate: 1590163200000
        // wordCount: 0

        commit(MutationTypes.SET_USERINFO,Cache.saveUserInfo(res.data))
        return resolve(res.data)

      })
    })
  },

  // 设置状态
  setLoginStatus({ commit }, query) {
    // 设置不同的登录状态

    commit(MutationTypes.SET_LOGIN_STATUS,Cache.saveLoginStatus(query))
  },
  // 登出
  fedLogOut({ commit }) {
    // 删除token，用户信息，登陆状态
    commit(MutationTypes.SET_TOKEN, '')
    commit(MutationTypes.SET_LOGIN_STATUS,0)
    
    Cache.removeToken()
    Cache.removeUserInfo()
    Cache.removeLoginStatus()
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



//////////////////
// WEBPACK FOOTER
// ./app/store/modules/user.js
// module id = null
// module chunks = 